import React from 'react';
import { breakpoint, Button, Grid, GridItem } from '@digitools/honest-ui';
import styled from 'styled-components';
import useTranslate from 'src/hooks/useTranslate';
import { AddRequestText } from '../../constants/AddAccommodationRequestText';
import AccomodationRequest from './AccommodationRequest';
import useAsDataContext from '../../hooks/useAsDataContext';
import { AddIcon, DeleteIcon } from '@digitools/honest-ui/icons';
const ButtonRow = styled(GridItem) `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xl-2);
  /* Text buttons sit flush with the content edge, like the mock */
  > * {
    padding: 0;
  }
  @media (min-width: ${breakpoint.md}) {
    flex-direction: row;
    gap: var(--spacing-xl-5);
  }
`;
const rowSpacing = { marginBlock: 'var(--spacing-xl-2)' };
const AddAccommodationRequest = () => {
    const { t } = useTranslate();
    const { requestGroup, setRequestGroup, requestCount, setRequestCount } = useAsDataContext();
    const maxRequestCount = 10;
    const addRequest = (e) => {
        e.preventDefault();
        if (requestCount < maxRequestCount) {
            setRequestCount((requestCount + 1));
            setRequestGroup([...requestGroup, <AccomodationRequest count={requestCount + 1} key={requestCount + 1}/>]);
        }
    };
    const removeRequest = (e) => {
        e.preventDefault();
        setRequestCount((requestCount - 1));
        setRequestGroup([...requestGroup.slice(0, requestCount - 1), ...requestGroup.slice(requestCount + 2)]);
    };
    return (<>
      <div>{requestGroup}</div>
      <Grid noGutter style={rowSpacing}>
        <ButtonRow colSpan={4} colSpanMd={6} colSpanLg={12} data-testid={'add-accommodation-request'}>
        {requestCount < maxRequestCount &&
            <Button label={t(AddRequestText.addrequestBtnEE)} type={'text'} onClick={addRequest} data-testid='add-request-btn' icon={<AddIcon width={24} height={24}/>}/>}
        {(requestCount <= maxRequestCount && requestCount > 1) &&
            <Button label={t(AddRequestText.removeRequestBtnEE)} type={'text'} onClick={removeRequest} data-testid='remove-request-btn' icon={<DeleteIcon width={24} height={24}/>}/>}
        </ButtonRow>
      </Grid>
    </>);
};
export default React.memo(AddAccommodationRequest);
